import { ReactElement } from 'react';

import FrontImage from '../assets/images/LandingPage/peer_learning.png';
import { Center } from '../components/_atoms/Center';
import MaxWidthContainer from '../components/_atoms/MaxWidthContainer';
import CheckListItemCard from '../components/_molecules/ChecklistItemCard';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';

const GdprPage: NextPageWithLayout = () => {
  return (
    <MaxWidthContainer style={{ marginTop: 40, marginBottom: 40 }}>
      <Center>
        <CheckListItemCard
          title="Quick overview"
          audience=""
          subTitle={
            <span>
              GDPR{' '}
              <span role="img" aria-label="Love">
                ❤️
              </span>
            </span>
          }
          actionButtonText="Need a DPA? Contact us now!"
          actionButtonRedirect="/contact-us"
          items={[
            {
              checked: true,
              text: 'DPA is available on request',
            },
            {
              checked: true,
              text: 'All data is processed and stored in Europe',
            },
          ]}
          readMore={{ text: 'Read more about Schrems 2', path: '/blog/schrems2' }}
        />
      </Center>
    </MaxWidthContainer>
  );
};

GdprPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Don’t worry. Curipod is built with privacy by design"
      subTitle="We are 100% GDPR compliant."
      primaryActionText="Sign up - It's free"
      image={FrontImage}
    >
      {page}
    </LandingPageLayout>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default GdprPage;
